export default __webpack_public_path__ + "static/media/mask.ddf2670b.svg";